import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  GetUploadLinkResponse,
  SaveUploadedFileParams,
  SaveUploadedFilePayload,
  SaveUploadedFilesResponse,
} from './upload.type';
import { publicRequest, request } from '../configs/axiosConfig';

export const UploadService = {
  getUploadBlobStorageUrl: async () => {
    return request<GetUploadLinkResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_UPLOAD_LINK,
    });
  },
  fetchHeadFile: async (url: string) => {
    return publicRequest({
      method: HTTPMethod.HEAD,
      url,
    });
  },
  saveUploadedFile: async (params: SaveUploadedFileParams, data: SaveUploadedFilePayload) => {
    return request<SaveUploadedFilesResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.SAVE_UPLOAD_INFORMATION,
      data,
      params,
    });
  },
};
